//@flow
import Constants   from   '../constants';
import APIInterface from '../APIInterfaces/quotes';
import Dispatcher  from '../dispatcher';

import type QuoteItemsCollection from '../Stores/Quote/quoteItemsCollection';
import type QuoteItemModel from '../Stores/Quote/quoteItemModel';

export default {
  updateQuote(quoteId:?string, quoteData:Object) {
    Dispatcher.dispatchAction(Constants.UPDATE_QUOTE, {quoteId, quoteData} );
  },

  deleteQuote(quoteId:string) {
    return APIInterface.deleteQuote(quoteId);
  },

  addQuoteItem(quoteId:?string, sku:?string, qty:number = 1, params:Object = {}) {
    Dispatcher.dispatchAction(Constants.ADD_QUOTE_ITEM, { quoteId, sku, qty, params });
  },

  addQuoteItems(quoteId:?string, quoteItems:Object[]) {
    Dispatcher.dispatchAction(Constants.ADD_QUOTE_ITEMS, { quoteId, quoteItems });
  },

  updateQuoteItemQty(item:QuoteItemModel, qty:number) {
    Dispatcher.dispatchAction(Constants.UPDATE_QUOTE_ITEM_QTY, {
      itemId: item.getId(),
      sku: item.getSku(),
      oldQty: item.getQty(),
      quoteId: item.getQuoteId(),
      qty,
    });
  },

  deleteQuoteItem(item:QuoteItemModel) {
    Dispatcher.dispatchAction(Constants.DELETE_QUOTE_ITEM, {
      itemId: item.getId(),
      oldQty: item.getQty(),
      sku: item.getSku(),
      quoteId: item.getQuoteId(),
      qty: 0,
    });
  },

  setUrlPromoCode(code:string) {
    Dispatcher.dispatchAction(Constants.SET_URL_PROMO_CODE, { code });
  },

  setPaymentInfo(quoteId:?string, vaultId:?string) {
    Dispatcher.dispatchAction(Constants.UPDATE_QUOTE_PAYMENT_INFO,
      { quoteId, vaultId });
  },

  setShippingAddress(quoteId:string, addressId:string) {
    Dispatcher.dispatchAction(Constants.SET_QUOTE_SHIPPING_ADDRESS, { quoteId, addressId });
  },

  setMustReserveQuote() {
    Dispatcher.dispatchAction(Constants.SET_MUST_RESERVE_QUOTE);
  },

  clearCheckoutStepState() {
    Dispatcher.dispatchAction(Constants.RESET_CHECKOUT_STEP_STATE);
  },

  setMembershipPricing(quoteId:string, membershipPricing:boolean) {
    Dispatcher.dispatchAction(Constants.UPDATE_MEMBERSHIP_PRICING, { quoteId, membershipPricing });
  },

  addItemAndSetSubscription(quoteId:string, quoteItems:QuoteItemsCollection, sku:string, quoteParams:Object = {}, onSuccess:() => void = () => {}) {
    const skuIsAdded = quoteItems.getQuoteItemBySku(sku);
    quoteParams.subscribe = true;


    if (!skuIsAdded) {
      quoteParams.items = [{ sku, qty: 1, params: {} }];
    }

    APIInterface.updateQuote(quoteId, quoteParams).onSuccess(onSuccess);
  },

  addItemAndSetPromoCode(quoteId:string, quoteItems:QuoteItemsCollection, sku:string, quoteParams:Object = {}, promoCode:string, onSuccess:() => void = () => {}, onFailure:() => void = () => {}) {
    const skuIsAdded = quoteItems.getQuoteItemBySku(sku);
    quoteParams.coupon_code = promoCode;

    if (!skuIsAdded) {
      quoteParams.items = [{ sku, qty: 1, params: {} }];
    }

    APIInterface.updateQuote(quoteId, quoteParams).onSuccess(onSuccess).onFailure(onFailure);
  },

  setMsrpCustomerGroup() {
    Dispatcher.dispatchAction(Constants.SET_MSRP_CUSTOMER_GROUP);
  },

  addShippingAddressCheckout(addressId:string, quoteId:string){
    Dispatcher.dispatchAction(Constants.ADD_SHIPPING_ADDRESS_CHECKOUT, {addressId, quoteId});
  },
};
